import { GridColDef } from "@mui/x-data-grid-pro";
import {
  GKClientDataGrid,
  GKModal,
  Grid2,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from "components";
import { useFetchQuery } from "hooks/useQueries";
import { ClientBasketInvestmentTradeList } from "interfaces/ClientBasket";
import {
  moneyCommaSeparator,
  moneyCommaSeparatorPoint,
  numberToCurrency,
} from "utils";
import { handleCapitalize } from "utils/common";
import { GKModalProps } from "utils/commonInterface";
import { extraColumnsField, matchDate } from "utils/helpers";

interface Props {
  selectOrderId: string;
}

const TradeDetailsModal = (props: GKModalProps & Props) => {
  const { open, setOpen, selectOrderId } = props;

  const { data, isFetching } = useFetchQuery({
    key: ["FETCH_CLIENT_BASKETS_INVESTMENT_TRADE"],
    route: `/client/order-trades/?order_id=${selectOrderId}`,
    enabled: !!selectOrderId,
  });

  const tradeHeaderDetails = [
    {
      title: "Investment Date",
      value: matchDate(data?.data?.data?.investmentDate),
    },
    {
      title: "Investment Type",
      value: handleCapitalize(data?.data?.data?.investmentType),
    },
    {
      title: "Total Investments",
      value: numberToCurrency(data?.data?.data?.executionTotalAmount),
    },
    {},
    {},
    {},
  ];

  const column: GridColDef[] = [
    {
      ...extraColumnsField("ASSETS NAME", "company", 250, 1),
    },
    {
      ...extraColumnsField("QTN", "quantity", 80, 1),
      type: "number",
      valueFormatter: (params) => moneyCommaSeparatorPoint(params.value),
      valueGetter: (params) => params.row.quantity || "0",
    },
    {
      ...extraColumnsField("AVG. BUY PRICE (₹)", "price", 150, 1),
      type: "number",
      valueFormatter: (params) => moneyCommaSeparator(params.value),
      valueGetter: (params) => params?.row?.price || "-",
    },
    {
      ...extraColumnsField("INVESTMENT AMOUNT (₹)", "totalAmount", 160, 1),
      type: "number",
      valueFormatter: (params) => moneyCommaSeparator(params.value),
      valueGetter: (params) => params?.row?.totalAmount || "-",
    },
  ];

  return (
    <GKModal
      modalTitle={"Trades Details"}
      open={open}
      setOpen={setOpen}
      loading={isFetching}
    >
      <Grid2 container spacing={3}>
        <Grid2 size={12}>
          <TableContainer style={{ borderRadius: "6px" }}>
            <Table>
              <TableBody>
                <TableRow sx={{}}>
                  {tradeHeaderDetails.map((item) => (
                    <TableCell
                      style={{
                        borderBottom: "none",
                        padding: 24,
                        width: "16%",
                        background: "#F8F8F8",
                      }}
                    >
                      <Typography fontSize={12} color={"var(--neutral-500)"}>
                        {item?.title}
                      </Typography>
                      <Typography fontSize={14} color={"#4F4F4F"}>
                        {item?.value}
                      </Typography>
                    </TableCell>
                  ))}
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Grid2>
        <Grid2 size={12}>
          <GKClientDataGrid
            loading={false}
            columns={column}
            rows={
              data?.data?.data?.trades?.map(
                (dataItem: ClientBasketInvestmentTradeList, index: number) => {
                  return {
                    ...dataItem,
                    id: index,
                  };
                },
              ) || []
            }
            name="investTradeDetails"
            density="compact"
          />
        </Grid2>
      </Grid2>
    </GKModal>
  );
};

export default TradeDetailsModal;
